import styled, { css } from 'styled-components';

import {
    Col,
} from '@zillow/zrs-comet';

const THEME_VALIDATION = 'props => props.theme && props.theme.ns';

export const StyledHeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    height: 24px;

    ${props => THEME_VALIDATION && css`
        margin: ${props.theme.ns().spacing.getSpacing(1)};
    `}
`;

export const StyledPropertyCol = styled(Col)`
    ${props => THEME_VALIDATION && props.flex && css`
        flex: ${props.flex};
    `}
`;
